import React, { useState, useEffect } from "react";
import axios from "axios";
import { CSVLink } from 'react-csv';
import { FileDown } from "lucide-react";

export default function Mailing({ changeMail, CategoryId }) {
    const headers = [
        { label: "ID", key: "id" },
        { label: "Nom", key: "nom" },
        { label: "Email", key: "email" }
    ];

    const [data, setData] = useState([]);
    const [selectedEmails, setSelectedEmails] = useState([]);
    const [currentPage, setCurrentPage] = useState(1);
    const [totalPages, setTotalPages] = useState(1);
    const [itemsPerPage] = useState(20);
    const [isSelectAll, setIsSelectAll] = useState(false);

    useEffect(() => {
        fetchData();
    }, [currentPage, CategoryId]);

    const fetchData = async () => {
        try {
            const response = await axios.get('/cvs_page', {
                params: {
                    page: currentPage,
                    per_page: itemsPerPage,
                    category_id: CategoryId // Pass the selected category ID
                }
            });
            setData(response.data.cvs); // Adjust based on API response structure
            setTotalPages(response.data.total_pages); // Adjust based on API response structure
        } catch (error) {
            console.error('Error fetching data:', error);
        }
    };

    const handleCheck = (email) => {
        setSelectedEmails(prevSelected =>
            prevSelected.includes(email)
                ? prevSelected.filter(e => e !== email)
                : [...prevSelected, email]
        );
    };

    const handleSelectAll = () => {
        setIsSelectAll(!isSelectAll);
        if (!isSelectAll) {
            setSelectedEmails(data.map(cv => cv.email));
        } else {
            setSelectedEmails([]);
        }
    };

    const handlePageChange = (page) => {
        if (page < 1 || page > totalPages) return;
        setCurrentPage(page);
    };

    const paginationItems = () => {
        const visiblePages = [];
        let startPage, endPage;

        if (totalPages <= 5) {
            startPage = 1;
            endPage = totalPages;
        } else {
            if (currentPage <= 3) {
                startPage = 1;
                endPage = 5;
            } else if (currentPage + 2 >= totalPages) {
                startPage = totalPages - 4;
                endPage = totalPages;
            } else {
                startPage = currentPage - 2;
                endPage = currentPage + 2;
            }
        }

        for (let i = startPage; i <= endPage; i++) {
            visiblePages.push(i);
        }

        return visiblePages.map(number => (
            <li
                key={number}
                className={`page-item ${number === currentPage ? 'active' : ''}`}
                aria-current={number === currentPage ? 'page' : undefined}
            >
                <button
                    className="page-link"
                    onClick={() => handlePageChange(number)}
                >
                    {number}
                </button>
            </li>
        ));
    };

    return (
        <>
            <div className="d-flex">
                <div className="p-2">Tous les listes des email</div>
                <div className="ml-auto p-2">
                    <CSVLink
                        data={data.map(cv => ({
                            id: `${cv.id}`,
                            nom: `${cv.nomPrenom}`,
                            email: `${cv.email}`
                        }))}
                        headers={headers}
                        className="btn btn-primary btn-sm"
                    >
                        <FileDown size={24} strokeWidth={1} /> Télécharger en format CSV
                    </CSVLink>
                </div>
            </div>
            <table className="table table-striped">
                <thead>
                    <tr>
                        <th scope="col">
                            <div className="form-check">
                                <input
                                    className=""
                                    onClick={handleSelectAll}
                                    type="checkbox"
                                    id="flexCheckDefault"
                                    checked={isSelectAll}
                                />
                            </div>
                        </th>
                        <th scope="col">ID</th>
                        <th scope="col">Nom et prénom</th>
                        <th scope="col">Email</th>
                    </tr>
                </thead>
                <tbody>
                    {data.map(cv => (
                        <tr key={cv.id}>
                            <th scope="row">
                                <div className="form-check">
                                    <input
                                        className=""
                                        type="checkbox"
                                        value={cv.email}
                                        id="flexCheckDefault"
                                        checked={selectedEmails.includes(cv.email)}
                                        onChange={(e) => {
                                            handleCheck(cv.email);
                                            changeMail(e);
                                        }}
                                    />
                                </div>
                            </th>
                            <td><strong>{cv.id}</strong></td>
                            <td>{cv.nomPrenom}</td>
                            <td>{cv.email}</td>
                        </tr>
                    ))}
                </tbody>
            </table>
            <nav aria-label="Page navigation">
                <ul className="pagination">
                    <li className={`page-item ${currentPage === 1 ? 'disabled' : ''}`}>
                        <button
                            className="page-link"
                            onClick={() => handlePageChange(currentPage - 1)}
                        >
                            Précédent
                        </button>
                    </li>
                    {currentPage > 3 && (
                        <>
                            <li className="page-item">
                                <button
                                    className="page-link"
                                    onClick={() => handlePageChange(1)}
                                >
                                    1
                                </button>
                            </li>
                            {currentPage > 4 && <li className="page-item disabled"><span className="page-link">...</span></li>}
                        </>
                    )}
                    {paginationItems()}
                    {currentPage < totalPages - 2 && (
                        <>
                            {currentPage < totalPages - 3 && <li className="page-item disabled"><span className="page-link">...</span></li>}
                            <li className="page-item">
                                <button
                                    className="page-link"
                                    onClick={() => handlePageChange(totalPages)}
                                >
                                    {totalPages}
                                </button>
                            </li>
                        </>
                    )}
                    <li className={`page-item ${currentPage === totalPages ? 'disabled' : ''}`}>
                        <button
                            className="page-link"
                            onClick={() => handlePageChange(currentPage + 1)}
                        >
                            Suivant
                        </button>
                    </li>
                </ul>
            </nav>
        </>
    );
}
